<template>
  <div class="SpecificExtraWorkRequest">
    <box class="" :title="this.$t('nav-specific-extrawork-request')">
      <div class="px-3 pt-2">
        <v-row>
          <v-col>
            <div>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <label for="sectionType">{{ $t("sectionType") }}: </label>
                    </td>
                    <td>
                      <div>
                        <v-select
                          hide-details
                          v-model="sectionType"
                          :items="sectionTypes"
                          :label="$t('sectionType')"
                          item-text="Name"
                          item-value="Code"
                          return-object
                          dense
                          solo
                          v-on:change="changeSectionType"
                          class="my-auto py-0"
                        ></v-select>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label for="period">{{ $t("period") }}: </label>
                    </td>
                    <td>
                      <div>
                        <v-select
                          hide-details
                          v-model="period"
                          :items="periodList"
                          :label="$t('period')"
                          item-text="Name"
                          item-value="Code"
                          return-object
                          dense
                          solo
                          v-on:change="changePeriod"
                          class="my-auto py-0"
                        ></v-select>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <span>{{ $t("maxExtraWork") }} : </span>
                    </td>
                    <td>
                      <span>{{ maxExtraWork }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="save">{{ $t("save") }}</v-btn>
        </v-card-actions>
      </div>
    </box>

    <box class="mt-2" :title="$t('specificExtraWorkList')">
      <div class="extraWorkList">
        <div v-if="list.length > 0">
          <specific-extra-work-request-list-web
            :pagination="true"
            :list="list"
            class="hidden-sm-and-down"
            @onClick="onClickEw()"
            @changeAmount="changeAmount"
          />
          <specific-extra-work-request-list-mob
            @onClick="onClickEW()"
            :list="list"
            class="hidden-md-and-up"
            @changeAmount="changeAmount"
          />
          <div class="d-flex pa-3 box-title-level-2">
            <v-spacer></v-spacer>
            <span> مجموع اضافه کارهای ویژه : {{ totalAmount }} </span>
          </div>
        </div>
        <!-- <div v-else>
          <EmptyList />
        </div> -->
      </div>
    </box>
  </div>
</template>

<script>
import SpecificExtraWorkRequestListMob from "../../components/requestManagement/specificextraworkRequest/SpecificExtraWorkRequestListMob.vue";
import SpecificExtraWorkRequestListWeb from "../../components/requestManagement/specificextraworkRequest/SpecificExtraWorkRequestListWeb.vue";
import EosToastType from "../../model/EosToastType";
//import AccessToType from '../../model/AccessToType';
import PeriodList from "../../model/PeriodList";
import ResultType from "../../model/ResultType";
import DateUtils from "../../utils/DateUtils";
import EosUtils from "../../utils/EosUtils";
import TextUtils from "../../utils/TextUtils";
export default {
  components: {
    SpecificExtraWorkRequestListWeb,
    SpecificExtraWorkRequestListMob,
  },
  data() {
    return {
      sectionType: "",
      sectionTypes: [],
      periodList: [],
      period: "",
      maxExtraWork: "0",
      list: [],
      totalAmount: 0,
    };
  },
  computed: {},
  mounted() {
    this.periodList = PeriodList.getArray();
    this.periodList.splice(0, 1);
    if (this.periodList.length > 0) {
      this.period = this.periodList[0];
    }

    this.getSectionTypes();
  },
  watch: {
    list() {
      this.list.forEach((item) => {
        item.minAmount = EosUtils.ConvertMinToHour(item.Amount);
      });
      this.setTotalAmount();
    },
  },
  methods: {
    setTotalAmount() {
      // //debugger;
      console.log("totalAmount");
      var total = 0;
      this.list.forEach((item) => {
        if (!item.minAmount.includes(":")) {
          item.minAmount = EosUtils.ConvertMinToHour(item.minAmount);
        }
        total = total + EosUtils.ConvertHourMinToMin(item.minAmount);
      });
      this.totalAmount = EosUtils.ConvertMinToHour(total);
    },
    GetPersonByExtraWorkBySection() {
    
      this.list = [];
// //debugger;
      var params = new URLSearchParams();
      params.append("section", this.sectionType.Code);
      params.append("period", this.period.Code);

      this.$store
        .dispatch("GetPersonByExtraWorkBySection", { params })
        .then((result) => {
          //console.log(result);
          if (result.type == ResultType.success) {
            this.list = result.data;
            // //debugger;
          }
        });
    },
    GetSpecificExtraWorkAmountForSection() {
      //debugger;
      var moment = require("jalali-moment");
      var year = moment().locale("fa").format("YYYY");

      var params = new URLSearchParams();
      params.append("year", year);
      params.append("section", this.sectionType.Code);
      params.append("period", this.period.Code);
// //debugger;
      this.$store
        .dispatch("GetSpecificExtraWorkAmountForSection", { params })
        .then((result) => {
          // //debugger;
          //console.log(result);
          if (result.type == ResultType.success) {
            // //debugger;
            this.maxExtraWork = EosUtils.ConvertMinToHour(result.data);
          } else {
            // //debugger;
            this.maxExtraWork = 0;
          }
        });
    },
    async getSectionTypes() {
      //debugger;
      this.sectionTypes = [];
      var IsFreeOfGroupManager = false;
      await this.$store.dispatch("IsFreeOfGroupManager").then((result) => {
        if (result.type === ResultType.success) {
          IsFreeOfGroupManager = result.data;
        }
      });

      if (IsFreeOfGroupManager) {
        this.$store.dispatch("sections/GetAllSections").then((result) => {
          ////console.log(result);
          if (result.type == ResultType.success) {
            this.sectionTypes.push(...result.data);
            if (this.sectionTypes.length > 0) {
              this.sectionType = this.sectionTypes[0];
            }
            this.GetSpecificExtraWorkAmountForSection();
            this.GetPersonByExtraWorkBySection();
          }
        });
      } else {
        this.$store
          .dispatch("sections/GetAllSectionsForManager")
          .then((result) => {
            //console.log(result);
            if (result.type == ResultType.success) {
              this.sectionTypes.push(...result.data.Table);
              this.sectionType = this.sectionTypes[0];
              this.GetSpecificExtraWorkAmountForSection();
              this.GetPersonByExtraWorkBySection();
            }
          });
      }
    },
    changeSectionType() {
      this.GetSpecificExtraWorkAmountForSection();
      this.GetPersonByExtraWorkBySection();
    },
    changePeriod() {
      this.GetSpecificExtraWorkAmountForSection();
      this.GetPersonByExtraWorkBySection();
    },
    async save() {
      //debugger;
      var moment = require("jalali-moment");
      var year = moment().locale("fa").format("YYYY");

      if (
        EosUtils.ConvertHourMinToMin(this.totalAmount) >
        EosUtils.ConvertHourMinToMin(this.maxExtraWork)
      ) {
        // //debugger;
        this.$EosToast.show({
          type: EosToastType.error,
          msg:
            // "سقف اضافه کار ویژه اختصاص یافته به قسمت انتخاب شده " +
            // this.maxExtraWork +
            // " است ",
            "مقدار اضافه کار ویژه تخصیص داده شده بیشتر از سقف اضافه کار است"
            
        });
        return;
      }

      if (!(this.list.length > 0)) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: "درخواستی برای ذخیره وجود ندارد",
        });
        return;
      }

      if (this.maxExtraWork == 0) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: "اضافه کار ویژه برای این دوره وقسمت کاری تعریف نشده است",
        });
        return;
      }

      var IsFreeOfGroupManager = false;
      await this.$store.dispatch("IsFreeOfGroupManager").then((result) => {
        if (result.type === ResultType.success) {
          IsFreeOfGroupManager = result.data;
          // //debugger;
        }
      });
      // //debugger;
      var adminSection = IsFreeOfGroupManager ? "-1" : this.sectionType.Code;

      var BeginPeriod = "";
      var EndPeriod = "";
      const params = new URLSearchParams();
      params.append("periodNumber", this.period.Code);
      params.append("year", year);
      /*if (this.args.perno) {
        params.append("employeeId", this.args.perno);
      }*/
      var result = await this.$store.dispatch("GetPeriodBeginAndEndDate", {
        params,
      });
      // //debugger;
      if (result.type === "success") {
        if (result.data.length > 0) {
          let data = result.data[0];
          console.log(data);
          BeginPeriod = data.BeginDate;
          EndPeriod = data.EndDate;
        }
      }
// //debugger;
      var promises = [];
      //console.log(this.list);
      this.list.forEach((item) => {
        var amount = EosUtils.ConvertHourMinToMin(item.minAmount);
        if ((item.Status == 0 || item.Status == 2) && amount > 0) {
          console.log(item);
          var params = new URLSearchParams();
          params.append("period", this.period.Code);
          params.append(
            "perno",
            TextUtils.convertToEnglishDigits(item.perno).toString().trim()
          );
          params.append("amount", amount);
          if (item.Status == 2) {
            // for update only
            params.append("pageno", item.PageNo);
          }
          //debugger;
          params.append("section", item.SECTION.toString().trim());
          params.append("year", year);
          params.append("adminSection", adminSection.toString().trim());
          params.append(
            "BeginPeriod",
            DateUtils.removeYearFromDate(BeginPeriod)
          );
          params.append("EndPeriod", DateUtils.removeYearFromDate(EndPeriod));
// //debugger;
          promises.push(
            this.$store.dispatch("InsertOrUpdateSpecialEW", { params })
            
          );
          //debugger;
        }
      });

      if (!(promises.length > 0)) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: "درخواست اضافه کار برای دوره و قسمت انتخاب شده قبلا انجام شده است",
        });
        return;
      }

      var results = await Promise.all(promises);
      console.log(results);
      if (results.find((res) => res.type == ResultType.error)) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: "ممکن است سطح تایید شما برای قسمت مورد نظر تعیین نشده باشد",
        });
      } else {
        // //debugger;
        this.$EosToast.show({
          type: EosToastType.success,
          msg: "عملیات با موفقیت انجام شد",
        });
      }

      /*if (results.find((p) => p.data != "1")) {
        if (results.find((res) => res.data == "-1")) {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: "ممکن است سطح تایید شما برای قسمت مورد نظر تعیین نشده باشد",
          });
        }
      } else {
        this.$EosToast.show({
          type: EosToastType.success,
          msg: "عملیات با موفقیت انجام شد",
        });
      }*/

      this.GetPersonByExtraWorkBySection();
    },
    onClickEw() {},
    changeAmount(list) {
      // //debugger;
      this.list = list;
      console.log(this.totalAmount);
      this.setTotalAmount();
    },
  },
};
</script>

<style>
</style>